var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('header',[_vm._t("header",null,{"title":_vm.means.title})],2),_c('main',[_vm._t("main",null,{"content":_vm.means.content})],2),_c('footer',[_vm._t("footer")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }